import type { SVGProps } from 'react';
const SvgDeck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#deck_svg__a)">
      <path d="M22 9 12 2 2 9h9v13h2V9h9Z" />
      <path d="m4.14 12-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9l-.76-4ZM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37-.76 4Z" />
    </g>
    <defs>
      <clipPath id="deck_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDeck;
